import httpClient from './http.client';
import config from '../config';

import { configureInterceptors } from './interceptors';

const host = config.serverHost;
httpClient.defaults.baseURL = config.serverHost;

configureInterceptors();

function buildUrlToFetch(baseUrl, params) {
  const query = new URLSearchParams(params).toString();
  return `${baseUrl}?${query}`;
}

// Nova versão para função getBilhetes com fetch
function requestFetch(path, params) {
  const url = buildUrlToFetch(`${host}/${path}`, params);

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }
  });
}

function request(path, params, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  return new Promise((resolve, reject) => {
    // console.log('REQUEST PARAMS: '+path, params);

    //    if (typeof params === 'object' && params !== null) {
    //       params = {qp: JSON.stringify(params)};
    //    } else {
    //       params = {qp: JSON.stringify({filterBy: {text: params}})};
    //    }

    //    params = null; // Temporary
    // console.log('Request: ', path, httpClient.defaults.baseURL, httpClient);
    httpClient
      .get(path, { params, showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err, true));
      });
  });
}

function post(path, params, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  let data = JSON.parse(JSON.stringify(params)); //to clear vue observables

  return new Promise((resolve, reject) => {
    httpClient
      .post(path, data, { showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

function put(path, params, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  let data = JSON.parse(JSON.stringify(params)); //to clear vue observables

  return new Promise((resolve, reject) => {
    httpClient
      .put(path, data, { showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

function destroy(path, options = {}) {
  const { showLoader = false, nameLoader = '' } = options || {};
  return new Promise((resolve, reject) => {
    httpClient
      .delete(path, { showLoader, nameLoader })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err, true));
      });
  });
}

function failHandler(error, req) {
  let ret = null;
  let msg = req ? '' : '';

  function msgParser(msg) {
    return msg; // window.getApp.$t(msg);
  }

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    ret = error.response.data;
    //    console.log('data', error.response.data);
    //    console.log('status', error.response.status);
    //    console.log('header', error.response.headers);
    msg += msgParser(error.response.data.msg) || error.response.statusText;
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log('request', error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
    msg += String.fromCharCode(10) + error.message;
  }
  // console.log('config', error.config);

  // Give feedback

  return ret;
}

function postFormData(path, params, options = {}) {
  const { showLoader = false, nameLoader = '', headers = {} } = options || {};
  let data = params;

  return new Promise((resolve, reject) => {
    httpClient
      .post(path, data, { showLoader, nameLoader, headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

function putFormData(path, params, options = {}) {
  const { showLoader = false, nameLoader = '', headers = {} } = options || {};
  let data = params;

  return new Promise((resolve, reject) => {
    httpClient
      .put(path, data, { showLoader, nameLoader, headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(failHandler(err));
      });
  });
}

export default {
  host,
  requestFetch,
  request,
  post,
  put,
  destroy,
  postFormData,
  putFormData
};
